require('../passwordRecovery/stylesheets/_registration.scss');

angular.module('pages.loginReminder', [])
	.config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
	$stateProvider
		.state('pages.login-reminder', {
			url: 'login-recovery',
			template: require('./templates/index.html'),
			controller: require('./controllers/loginReminder.controller'),
			data: {
				iframe: false
			},
			pageTrack: '/loginReminder'
		})
}

module.exports = 'pages.loginReminder';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/loginReminder/index.js
 ** module id = 267
 ** module chunks = 1
 **/